<template>
  <section class="content">
    <div class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div class="row">
            <div class="col-12">
              <h1>{{translate('messages.feeds')}}</h1>
            </div>
          </div>
          <div class="row">

            <div class="col-12">
          
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">{{translate('messages.feeds_list')}}</h3>

                  <div class="card-tools">
                    <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                        <i class="fa fa-plus-square"></i>
                        {{translate('messages.add_new')}}
                    </button>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive p-0">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{translate('messages.keyword')}}</th>
                        <th>{{translate('messages.country')}}</th>
                        <th>{{translate('messages.language')}}</th>
                        <th v-if="$gate.hasFeaturePermission('feed_submissions')">{{translate('messages.submissions')}}</th>
                        <th>{{translate('messages.options')}}</th>
                        <th>{{translate('messages.actions')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="feed in feeds.data" :key="'feed-'+feed.id">

                        <td><span class="mr-2" style="border-radius:0.25rem; width: 1.5rem; height: 1.5rem; display: inline-block; vertical-align: middle;" :style="'background:'+(feed.color ? feed.color : '#01a0c7')"></span><span style="vertical-align: middle;">{{feed.keyword}}</span></td>
                        <td>{{feed.country}}</td>
                        <td>{{feed.language}}</td>
                        <td v-if="$gate.hasFeaturePermission('feed_submissions')">
                          <toggle-button :value="feed.active_submission == 1 ? true : false"
                            :labels="true"
                            @change="setActiveSubmission"
                            :name="feed.id.toString()"
                            />
                        </td>
                        <td>
                          <ul class="fa-ul">
                            <li v-if="feed.type=='smart'" class="my-1"><span class="fa-li"><i class="wi wi-sparkle fa-lg"></i></span>{{translate('messages.smart_feed')}}</li>
                            <li v-if="feed.advanced_search" class="my-1"><span class="fa-li"><i class="wi wi-advanced-search fa-lg"></i></span>{{translate('messages.advanced_search_active')}}</li>
                          </ul>
                        </td>
                        <td>
                          
                          <a @click="editModal(feed)" class="btn btn-link mb-1" v-tooltip:top="translate('messages.update')" data-toggle="tooltip">
                              <i class="fa fa-edit blue"></i>
                          </a>
                          
                          <a @click="deleteFeed(feed.id)" class="btn btn-link mb-1" v-tooltip:top="translate('messages.delete')" data-toggle="tooltip">
                              <i class="fa fa-trash red"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="!feeds.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                    <pagination :data="feeds" @pagination-change-page="getResults"></pagination>
                </div>
              </div>
              <!-- /.card -->
            </div>
          </div>
      </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">{{translate('messages.create_feed')}}</h5>
                    <h5 class="modal-title" v-show="editmode">{{translate('messages.update_feed')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateFeed() : createFeed()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{translate('messages.keyword')}}</label>
                            <input v-model="form.keyword" type="text" name="keyword"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('keyword') }">
                            <has-error :form="form" field="keyword"></has-error>
                        </div>
                        <div class="form-group">
                          <label>{{translate('messages.country')}}</label>
                          <select class="form-control" v-model="form.country" :class="{ 'is-invalid': form.errors.has('country') }">
                            <option 
                                v-for="(country,code) in countries" :key="'country-'+code"
                                :value="code"
                                :selected="code == form.country">{{ country }}</option>
                          </select>
                          <has-error :form="form" field="country"></has-error>
                        </div>
                        <div class="form-group">
                          <label>{{translate('messages.language')}}</label>
                          <select class="form-control" v-model="form.language" :class="{ 'is-invalid': form.errors.has('language') }">
                          <option 
                              v-for="(language,index) in languages" :key="'lang-'+index"
                              :value="index"
                              :selected="index == form.language">{{ language }}</option>
                          </select>
                          <has-error :form="form" field="language"></has-error>
                        </div>
                        <div v-if="$gate.hasFeaturePermission('smart_feeds')" class="form-group">
                          <toggle-button v-model="form.is_smart"
                            :labels="true"
                            :sync="true"
                            @change="setSmart"
                            />
                          <label for="is-smart" class="pl-2">
                            {{translate('messages.activate_smart_feed')}}
                          </label> <i role="button" class="fas fa-question-circle fa-lg" v-popover:right="{title:translate('messages.how_to_use'), content:translate('messages.smart_feeds_help')}" data-toggle="popover"></i>
                          <has-error :form="form" field="is_smart"></has-error>
                        </div>
                        <div class="form-group">
                          <toggle-button v-model="form.has_advanced_search"
                            :labels="true"
                            :sync="true"
                            />
                          <label for="has_advanced_search" class="pl-2">
                            {{translate('messages.advanced_search')}}
                          </label>
                        </div>
                        <div id="advanced-search" v-if="this.form.has_advanced_search">
                          <div class="form-group" v-for="(input, index) in advanced_search" :key="'input-'+index">
                            <label>{{translate('messages.'+index)}} <small>({{translate('messages.optional')}})</small></label> <i role="button" class="fas fa-question-circle fa-lg" v-popover:right="{title:translate('messages.how_to_use'), content:translate('messages.'+index+'_help')}" data-toggle="popover"></i>
                            <vue-tags-input v-model="advanced_search[index].tag" type="text" :name="index" :class="{ 'is-invalid': form.errors.has(index) }" :tags="advanced_search[index].tags" @tags-changed="newTags => advanced_search[index].tags = newTags" :placeholder="translate('messages.add_term')"/>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{translate('messages.color')}}</label>
                          <div>
                            <div>
                              <color-picker :value="form.color ? form.color : '#01a0c7'" :disableAlpha="true" @input="changeFeedColor"/>
                              <has-error :form="form" field="color"></has-error>
                            </div>
                            <div>
                              <div class="card feed" style="max-width: 500px; min-width: 250px">
                                <div class="card-header" :style="'background: '+(form.color ? form.color : '#01a0c7')"  :class="form.color ? $options.filters.text_color_class(form.color) : ''">
                                    <h3 class="card-title py-1 my-0">
                                    {{form.keyword}} 
                                    </h3>
                                    <div class="card-tools">
                                        <span class="btn btn-tool no-shadow">
                                            <radar :monitoring="false"/>
                                        </span>
                                        <span class="btn btn-tool"><i class="fas fa-expand"></i>
                                        </span>
                                    </div>
                                </div>
                                <!-- /.card-header -->
                                <div class="card-body" style="height: 20px;">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
      components: {
          VueTagsInput,
        },
        data () {
            return {
                editmode: false,
                feeds : {},
                form: new Form({
                    id : '',
                    keyword: '',
                    color: '',
                    language: '',
                    country: '',
                    type: '',
                    has_advanced_search: false,
                    is_smart: false
                }),
                loading : true,
                active_submission : null,
                countries: [],
                languages: [],
                skip_set_active_submission : false,
                page : 1,
                advanced_search: {
                  exact_keywords: {
                    tag: '',
                    tags: []
                  },
                  excluded_keywords: {
                    tag: '',
                    tags: []
                  },
                  in_title: {
                    tag: '',
                    tags: []
                  },
                  in_websites: {
                    tag: '',
                    tags: []
                  },
                  excluded_websites: {
                    tag: '',
                    tags: []
                  },
                },
                skip_set_smart: false,
                smart_feeds_updates: {},
                smart_feed_counts: 0
            }
        },
        methods: {

          getResults(page = 1) {

              this.$Progress.start();
              this.page = page;
              axios.get('/api/feed?page=' + page).then(({ data }) => {
                this.feeds = data.data;
                this.loading = false;
                this.$Progress.finish();
                if(!this.feeds.data.length && this.page > 1){
                  this.getResults(this.page - 1);
                }
              });
          },
          loadCountries(){
            axios.get("/api/feed/countries").then(({ data }) => {this.countries = data.data;});
          },
          loadLanguages(){
            axios.get("/api/feed/languages").then(({ data }) => {this.languages = data.data;});
          },
          editModal(feed){
              this.editmode = true;
              this.form.reset();
              this.form.errors.clear();
              this.form.fill(feed);
              Object.keys(this.advanced_search).forEach((input) => {
                this.advanced_search[input].tags = [];
              });
              if(feed.advanced_search){
                this.form.update({
                  has_advanced_search: true,
                });
                Object.keys(this.advanced_search).forEach((input) => {
                  this.advanced_search[input].tags = feed.advanced_search[input].map(value => ({text: value}))
                });
              }
              if(feed.type == 'smart'){
                this.form.update({is_smart: true});
                this.loadInfo().then(() => {
                  let message = translate('messages.you_have')+' '+this.smart_feeds_updates.remaining+' '+translate('messages.remaining_smart_feeds_updates_this_month');
                  this.form.errors.set('is_smart', message);
                });

              }
              
              $('#addNew').modal('show');
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              this.form.errors.clear();
              Object.keys(this.advanced_search).forEach((input) => {
                this.advanced_search[input].tags = [];
              });
              this.form.update({
                color:'#01a0c7',
                has_advanced_search: false,
                is_smart: false
              });
              $('#addNew').modal('show');
          },
          createFeed(){
              this.$Progress.start();
              this.form.update({_method:'post'});
              if(this.form.has_advanced_search){
                var update = {}
                Object.keys(this.advanced_search).forEach((input) => {
                  update[input] = JSON.stringify(this.advanced_search[input].tags.map(value => (value.text)))
                });
                this.form.update(update);
              }
              this.form.update({type: this.form.is_smart ? 'smart' : null});
              this.form.post('/api/feed')
              .then((response)=>{
                $('#addNew').modal('hide');

                Toast.fire({
                      icon: 'success',
                      title: response.data.message
                  });
                this.$Progress.finish();
                this.getResults();
              })
              .catch((error)=>{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              })
          },
          updateFeed(){
              this.$Progress.start();
              this.form.update({_method:'put'});
              if(this.form.has_advanced_search){
                var update = {}
                Object.keys(this.advanced_search).forEach((input) => {
                  update[input] = JSON.stringify(this.advanced_search[input].tags.map(value => (value.text)))
                });
                this.form.update(update);
              }
              
              this.form.update({type: this.form.is_smart ? 'smart' : null});
             
              this.form.post('/api/feed/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');
                  this.getResults(this.page);
              })
              .catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              });

          },
          deleteFeed(id){
            Swal.fire({
              title: window.translate('messages.are_you_sure'),
              text: window.translate('messages.no_revert'),
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.delete_confirm')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  this.form.delete('/api/feed/'+id).then((response)=>{
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.getResults(this.page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
              })
          },
          setActiveSubmission(event){
            if(this.skip_set_active_submission){
              this.skip_set_active_submission = false;
              return;
            }
            let state = event.value;
            let id = event.srcEvent.target.name
            this.$Progress.start();
            axios.post("/api/feed/setActiveSubmission/"+id, {active_submission:state}).then(({ data }) => {
              Toast.fire({
                icon: 'success',
                title: data.message
              });
              this.$Progress.finish();
            }).catch((error)=> {
              if(error.request.status == 412 && state){
                Swal.fire({
                  title: window.translate('messages.no_mobile_phone'),
                  text: window.translate('messages.update_it_on_profile'),
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
                  cancelButtonText: window.translate('messages.cancel'),
                  confirmButtonText: window.translate('messages.go_to_profile')
                }).then((result) => {
                  if (result.value) {
                    this.$router.push('profile')
                  }
                });
              }else{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                  icon: 'error',
                  title: error_title
                });
              }
              this.skip_set_active_submission = true;
              $(event.srcEvent.target).trigger('click');
              this.$Progress.fail();
            });
          },
          changeFeedColor(color){
            this.form.update({color:color.hex})
          },
          loadInfo(){
            return axios.get('/api/feed/info/'+this.form.id).then(({ data }) => {
              this.smart_feed_counts = data.data.smart_feeds_count;
              this.smart_feeds_updates = data.data.user_features_usage.smart_feeds_updates;
            });
          },
          setSmart(event){
            if(this.skip_set_smart){
              this.skip_set_smart = false;
              return;
            }
            let state = event.value;
            if(state){
              this.loadInfo().then(() => {
                if(this.smart_feed_counts > 0){
                  this.skip_set_smart = true;
                  $(event.srcEvent.target).trigger('click');
                  this.form.errors.set('is_smart', translate('messages.smart_feeds_limit_reached_message'));
                  return;
                }else{
                  let message = translate('messages.you_have')+': '+this.smart_feeds_updates.remaining+' '+translate('messages.remaining_smart_feeds_updates_this_month');
                  this.form.errors.set('is_smart', message);
                }
              });
            }else{
              this.form.errors.clear('is_smart');
            }
          }
        },
        mounted() {
          $('#addNew').on('hide.bs.modal', function () {
            $('[data-toggle="popover"]').popover('hide');
          });
        },
        created() {
          this.loadCountries();
          this.loadLanguages();
          this.getResults();
        }
    }
</script>
